import { postRequest } from 'utils/httpServices';
import axiosIns from 'utils/axios';

class merchantAPI {
  static list = (queryData = {}, config = {}) => {
    return postRequest(`v1/get-lead-data`, queryData, config).catch((error) => ({
      success: false,
      data: (error.response && error.response.data) || {},
      status: (error.response && error.response.status) || 400
    }));
  };

  static summary = (queryData = {}, config = {}) => {
    return postRequest(`v1/get-partner-merchant-summary`, queryData, config).catch((error) => ({
      success: false,
      data: (error.response && error.response.data) || {},
      status: (error.response && error.response.status) || 400
    }));
  };

  static info = (queryData = {}, config = {}) => {
    return postRequest(`v1/get-partner-merchant-basic-details`, queryData, config).catch(
      (error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400
      })
    );
  };

  static markupConfigData = (queryData = {}, config = {}) => {
    return postRequest(`v1/get-merchant-markup-data`, queryData, config).catch((error) => ({
      success: false,
      data: (error.response && error.response.data) || {},
      status: (error.response && error.response.status) || 400
    }));
  };

  static markupConfigSubmit = (queryData = {}, config = {}) => {
    return postRequest(`v1/send-mdr-request-mail`, queryData, config).catch((error) => ({
      success: false,
      data: (error.response && error.response.data) || {},
      status: (error.response && error.response.status) || 400
    }));
  };

  static kycVerify = (queryData = {}, config = {}) => {
    return postRequest(`v1/get-kyc-url`, queryData, config).catch((error) => ({
      success: false,
      data: (error.response && error.response.data) || {},
      status: (error.response && error.response.status) || 400
    }));
  };

  static InitiateSalesForceSignIn = (queryData = {}, config = {}) => {
    return postRequest(`v1/oidc/initiate-salesforce-sso`, queryData, config);
  };

  static downloadableReport = (queryData = {}, config = {}) => {
    return axiosIns
      .request({
        url: 'v1/download-partner-merchant-data',
        method: 'POST',
        responseType: 'blob',
        data: queryData,
        headers: config.headers
      })
      .catch(() => ({ success: false, data: 'Something went wrong', status: 500 }));
  };

  static downloadableGTVReport = (queryData = {}, config = {}) => {
    return axiosIns
      .request({
        url: 'v1/download-gtv-summary',
        method: 'POST',
        responseType: 'blob',
        data: queryData,
        headers: config.headers
      })
      .catch(() => ({ success: false, data: 'Something went wrong', status: 500 }));
  };

  static updateConsent = (queryData = {}, config = {}) => {
    return postRequest(`v1/update-partner-consent`, queryData, config).catch((error) => ({
      success: false,
      data: (error.response && error.response.data) || {},
      status: (error.response && error.response.status) || 400
    }));
  };

  static raiseProductRequest = (queryData = {}, config = {}) => {
    return postRequest(`v1/raise-product-request-mail`, queryData, config).catch((error) => ({
      success: false,
      data: (error.response && error.response.data) || {},
      status: (error.response && error.response.status) || 400
    }));
  };

  static updateCareSpoc = (queryData = {}, config = {}) => {
    return postRequest(`v1/update-care-spoc`, queryData, config).catch((error) => ({
      success: false,
      data: (error.response && error.response.data) || {},
      status: (error.response && error.response.status) || 400
    }));
  };

  static activatePlan = (queryData = {}, config = {}) => {
    return postRequest(`v1/activate-plan`, queryData, config).catch((error) => ({
      success: false,
      data: (error.response && error.response.data) || {},
      status: (error.response && error.response.status) || 400
    }));
  };

  static fetchRmMappingDetails = (queryData = {}, config = {}) => {
    return postRequest(`v1/get-rm-mapping-details`, queryData, config).catch((error) => ({
      success: false,
      data: (error.response && error.response.data) || {},
      status: (error.response && error.response.status) || 400
    }));
  };

  static TransctionSummary = (queryData = {}, config = {}) => {
    return postRequest(`v1/set_partner_merchants_aggregated_data`, queryData, config).catch(
      (error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400
      })
    );
  };

  static fetchNavigationFlag = (queryData = {}, config = {}) => {
    return postRequest(`v1/update-dashboard-navigation-guide`, queryData, config).catch(
      (error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400
      })
    );
  };

  static createReferralSignup = (queryData = {}, config = {}) => {
    return postRequest(`v1/create-referral-signup`, queryData, config).catch((error) => ({
      success: false,
      data: (error.response && error.response.data) || {},
      status: (error.response && error.response.status) || 400
    }));
  };

  static fetchPartnerBaseRateDetails = (queryData = {}, config = {}) => {
    return postRequest(`v1/get-partner-base-rate`, queryData, config).catch((error) => ({
      success: false,
      data: (error.response && error.response.data) || {},
      status: (error.response && error.response.status) || 400
    }));
  };

  static requestPartnerBaseRateDetails = (queryData = {}, config = {}) => {
    return postRequest(`v1/request-partner-base-rate-change`, queryData, config).catch((error) => ({
      success: false,
      data: (error.response && error.response.data) || {},
      status: (error.response && error.response.status) || 400
    }));
  };

  static merchantBaseRateConfigData = (queryData = {}, config = {}) => {
    return postRequest(`v1/get-partner-merchant-base-rate-markup`, queryData, config).catch(
      (error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400
      })
    );
  };

  static updateOnboardingNotification = (queryData = {}, config = {}) => {
    return postRequest(`v1/update-onboarding-notifcation`, queryData, config).catch((error) => ({
      success: false,
      data: (error.response && error.response.data) || {},
      status: (error.response && error.response.status) || 400
    }));
  };

  static fetchSettingsConfig = (queryData = {}, config = {}) => {
    return postRequest(`v1/get-general-config`, queryData, config).catch((error) => ({
      success: false,
      data: (error.response && error.response.data) || {},
      status: (error.response && error.response.status) || 400
    }));
  };

  static fetchNotificationConfig = (queryData = {}, config = {}) => {
    return postRequest(`v1/get-notification-config`, queryData, config).catch((error) => ({
      success: false,
      data: (error.response && error.response.data) || {},
      status: (error.response && error.response.status) || 400
    }));
  };
}

export default merchantAPI;
